import { USER_PERMISSION, type UserPermissionCode } from '@glyphic/user-api-types'

import { useUserAuthorization } from '../context/UserAuthorizationContext'

export function useUserPerm(code?: UserPermissionCode | string) {
  const { hasPerm } = useUserAuthorization()
  return hasPerm(code)
}

export { USER_PERMISSION }
